import { Button } from '@kodkafa/reform';
import { NextPrevious, Task, Widget, WidgetProps } from '@/components';
import taskCompletedSvg from '@/assets/images/task-completed.svg';
import { useTranslation } from 'react-i18next';
import {
  TaskControllerFindTasksByFiltersApiArg,
  TaskPublicDtoRead,
  useLazyTaskControllerFindTasksByFiltersQuery,
} from '@/store/services/MidleNestApi.service';
import React, { useEffect, useState } from 'react';
import { useInit } from '@/hooks';
import EmptyTasks from '@/assets/images/EmptyTasks';

interface QuestListProps extends WidgetProps {
  link?: string;
  customer?: string;
  hideCustomer?: string;
  showViewAll?: boolean;
  showStatusFilters?: boolean;
  showOtherFilters?: boolean;
  defaultPlatform?: string;
  showPages?: boolean;
  quests?: TaskPublicDtoRead[] | null;
  taskCount?: number;
  splitQuests?: boolean;
  type?: string;
  limit?: number;
}

export default function QuestList({
  type,
  showStatusFilters,
  showOtherFilters,
  taskCount,
  defaultPlatform = '',
  limit = 12,
  customer,
  hideCustomer,
  className,
  ...props
}: QuestListProps) {
  const { t } = useTranslation();
  const { getPlatforms } = useInit();

  const [loading, setLoading] = useState<boolean>(true);

  const [page, setPage] = useState<number>(1);

  const [currentTotalPage, setCurrentTotalPage] = useState(
    taskCount ? Math.ceil(taskCount / limit) : 1,
  );
  // const currentTasks: TaskPublicDto[] = [];
  const [currentTasks, setCurrentTasks] = useState<TaskPublicDtoRead[]>();
  const [platform, setPlatform] = useState<string>(defaultPlatform);
  // const [action, setAction] = useState<string>('');

  const [getTasksByFilter] = useLazyTaskControllerFindTasksByFiltersQuery();

  useEffect(() => {
    setPage(1);
    handleTaskFunction(1).then((r) => console.log(r));
  }, [platform]);

  useEffect(() => {
    handleTaskFunction().then((r) => console.log({ currentTasks }));
  }, [page]);

  const handleTaskFunction = async (pageParam?: number) => {
    const filters: TaskControllerFindTasksByFiltersApiArg = {
      date: type ? { main: 'main', left: 'hot', right: 'maxPoint' }[type] : 'hot',
      page: pageParam || page,
      limit: 12,
      platform,
      customer,
      hideCustomer,
      // action,
    };

    getTasksByFilter(filters)
      .unwrap()
      .then((res) => {
        setCurrentTasks(res.list);
        setCurrentTotalPage(res?.total ? Math.ceil(res?.total / limit) : 1);
        setLoading(false);
      })
      .catch((e) => {
        console.log('error', e);
      });
  };

  return (
    <Widget
      {...props}
      loading={loading}
      className={`min-h-full ${className}`}
      actions={
        <div className='flex space-x-4'>
          {showOtherFilters && (
            <div className='flex space-x-4'>
              <select
                name='platform'
                style={
                  {
                    // filter:
                    //   'invert(77%) sepia(68%) saturate(389%) hue-rotate(342deg) brightness(105%) contrast(101%)',
                  }
                }
                className='w-max select-dark-mode py-2 rounded-xl'
                // placeholder={t('Platform') || 'Platform'}
                // options={providersPlatforms}
                onChange={(e) => setPlatform(e.currentTarget.value)}
              >
                <option value=''>All</option>
                {getPlatforms()?.map((i) => (
                  <option key={i.value} value={i.value}>
                    {i.label.charAt(0).toUpperCase() + i.label.slice(1)}
                  </option>
                ))}
              </select>
            </div>
          )}
          {showStatusFilters && (
            <div className='hidden md:flex'>
              <Button className='bg-blue-50 text-blue-500 hover:text-white px-4 py-2 rounded-xl'>
                {t('Remaining')}
              </Button>
              {/*<Button className='bg-transparent text-blue-500 hover:text-white px-4 py-2 rounded-xl'>*/}
              {/*  {t('Completed')}*/}
              {/*</Button>*/}
            </div>
          )}
        </div>
      }
    >
      <div className='md:flex md:flex-wrap -mx-4'>
        {/*<pre>{JSON.stringify(currentTasks, null, 2)}</pre>*/}
        {/*{console.log({ currentTasks })}*/}
        {currentTasks?.length && currentTasks.length > 0 ? (
          currentTasks?.map((task, idx) => (
            <div key={task.id} className='px-4 pb-2  md:w-1/2 lg:w-1/3'>
              <Task
                customId={`${props.title?.toString() || ''}-${idx.toString()}`}
                {...task}
                className='pb-2 border-b dark:border-b-[#655A38]'
              />
            </div>
          ))
        ) : (
          <div className='w-full h-full flex flex-col items-center justify-center'>
            {/* <img src={taskCompletedSvg} alt='No Task' className='w-40 md:w-56' /> */}
            <EmptyTasks />
            <div className='text-slate-400 dark:text-white my-3 md:mb-0'>
              {t('New tasks will be coming soon...')}
            </div>
          </div>
        )}
      </div>
      {(currentTotalPage ?? 1) > 1 && !!currentTasks?.length && (
        <NextPrevious page={page ?? 1} totalPage={currentTotalPage} setPage={setPage} />
      )}
    </Widget>
  );
}
